export default __webpack_public_path__ + "static/media/description.37d8084a.jpg";